module.exports = __webpack_public_path__ + "img/debate.91d692d7.png";